import StatusChip from "../../common/components/StatusChip";

interface ChangeSetStatusChipProps {
	status: string;
	size?: "small" | "medium";
}

const statusColors: Record<string, "success" | "info" | "default"> = {
	Active: "success",
	Complete: "info",
	Cancelled: "default",
};

export default function ChangeSetStatusChip({ status, size = "small" }: ChangeSetStatusChipProps) {
	return <StatusChip status={status} colorMap={statusColors} defaultColor="default" size={size} />;
}
